import styles from './PromptConfiguration.module.css'
import { BEDROCK_MODEL_IDS } from '../../../../global/constants/bedrock-models'

interface ModelSelectorProps {
  selectedModel: string
  setSelectedModel: (model: string) => void
  lastSavedModelToLocalStorage: Date | null
  formatTimestamp: (date: Date | null) => string
}

function ModelSelector({
  selectedModel,
  setSelectedModel,
  lastSavedModelToLocalStorage,
  formatTimestamp,
}: ModelSelectorProps) {
  return (
    <div className={styles.modelSelection}>
      <h3 className={styles.sectionLabel}>AI Model</h3>
      <select
        className={styles.modelSelect}
        value={selectedModel}
        onChange={(e) => setSelectedModel(e.target.value)}
      >
        <option value={BEDROCK_MODEL_IDS.CLAUDE_SONNET_4_5}>
          Claude Sonnet 4.5 (Best accuracy, higher cost)
        </option>
        <option value={BEDROCK_MODEL_IDS.CLAUDE_HAIKU_4_5}>
          Claude Haiku 4.5 (Faster, lower cost)
        </option>
      </select>
      <div className={styles.autoSaveIndicator}>
        Locally saved: {formatTimestamp(lastSavedModelToLocalStorage)}
      </div>
    </div>
  )
}

export default ModelSelector
